module.exports = __webpack_public_path__ + "assets/img/SportsFever360-Ludimos.df2560e9.jpg";